function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { isSsr } from "../../Utils/Utils";
export var ParallaxMover = /*#__PURE__*/function () {
  function ParallaxMover() {
    _classCallCheck(this, ParallaxMover);
  }

  _createClass(ParallaxMover, [{
    key: "init",
    value: function init() {}
  }, {
    key: "isEnabled",
    value: function isEnabled(particle) {
      return !isSsr() && !particle.destroyed && particle.container.actualOptions.interactivity.events.onHover.parallax.enable;
    }
  }, {
    key: "move",
    value: function move(particle) {
      var container = particle.container,
          options = container.actualOptions;

      if (isSsr() || !options.interactivity.events.onHover.parallax.enable) {
        return;
      }

      var parallaxForce = options.interactivity.events.onHover.parallax.force,
          mousePos = container.interactivity.mouse.position;

      if (!mousePos) {
        return;
      }

      var canvasCenter = {
        x: container.canvas.size.width / 2,
        y: container.canvas.size.height / 2
      },
          parallaxSmooth = options.interactivity.events.onHover.parallax.smooth,
          factor = particle.getRadius() / parallaxForce,
          centerDistance = {
        x: (mousePos.x - canvasCenter.x) * factor,
        y: (mousePos.y - canvasCenter.y) * factor
      };
      particle.offset.x += (centerDistance.x - particle.offset.x) / parallaxSmooth;
      particle.offset.y += (centerDistance.y - particle.offset.y) / parallaxSmooth;
    }
  }]);

  return ParallaxMover;
}();